import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import ScriptCustomOption from '@components/DevUI/scripts/ScriptCustomOption';
import { css } from '@emotion/react';
import { GridContainerVertical } from '@lusha-ui/core';
import { CloseIcon } from '@lusha-ui/icons';
import { Text } from '@lusha-ui/text';
import _ from 'lodash';
import React, { useMemo } from 'react';
import { messaging } from '../../../lib/messaging';
import { useAppSelector } from '../../../reducers';
import ScriptOption from './ScriptOption';
const optionsDefault = [
    { label: 'localhost', value: 'https://plugin-local.lusha.com:3013' },
    { label: 'Staging', value: 'https://plugin-staging.lusha.com' },
];
function Scripts(props) {
    const { onClose } = props;
    const { frameUrl } = useAppSelector(state => ({
        frameUrl: state.settings.frameUrl,
    }));
    const optionSelected = _.find(optionsDefault, option => option.value === frameUrl);
    const options = useMemo(() => {
        // automatically add override
        const arr = [...optionsDefault];
        return arr;
    }, []);
    function onChange(txt) {
        messaging.sendMessage('STORAGE/LOCAL/SET', { frameUrl: txt });
    }
    return (_jsxs("div", { css: css `
        background: #fff;
        padding: 0 10px 15px;
        border: 1px solid rgba(0, 0, 0, 0.3);
        position: fixed;
        left: 10px;
        right: 10px;
        border-radius: 8px;
      `, children: [_jsx("div", { onClick: onClose, css: css `
          position: absolute;
          top: 10px;
          right: 10px;
          cursor: pointer;
        `, children: _jsx(CloseIcon, { size: 12 }) }), _jsx(Text, { variant: 'body-2-s', css: css `
          margin-bottom: 5px;
        `, children: "Environment:" }), _jsxs(GridContainerVertical, { gap: 7, children: [_.map(options, option => (_jsx(ScriptOption, { value: option.value, label: option.label, checked: frameUrl === option.value, onChange: onChange }, 'script/' + option.value))), _jsx(ScriptCustomOption, { url: frameUrl, checked: !!frameUrl && !optionSelected, onChange: onChange })] })] }));
}
export default Scripts;
